'use client';

import { Stack } from '@chakra-ui/react';
import BrandCartCard from './BrandCartCard';
import { IRedux } from '@/_store/types';
import { BRAND_NAMES } from '@/_utils/Constants';

interface BrandCartListProps {
  cart: IRedux['cart']['cart'];
  onClear: (shipperId: string) => void;
  onRestaurant: (shipperId: string) => void;
  onCheckout: (shipperId: string) => void;
  onClosePopover: () => void;
}

export default function BrandCartList({
  cart,
  onClear,
  onRestaurant,
  onCheckout,
  onClosePopover,
}: BrandCartListProps) {
  return (
    <Stack gap={2} bg='light.300' rounded={16}>
      {Object.entries(cart).map(([shipperId, data]) => data?.products?.length > 0 && (
        <BrandCartCard
          key={shipperId}
          products={data?.products}
          onClear={() => onClear(shipperId)}
          brandName={BRAND_NAMES[shipperId]}
          onCheckout={() => onCheckout(shipperId)}
          onRestaurant={() => onRestaurant(shipperId)}
          onClosePopover={onClosePopover}
        />
      ))}
    </Stack>
  );
}
